import { classNames, convertMicroAlgosToUsd } from 'helpers/utilities'
import { useStore } from 'store/state/store'

interface UsePriceProps {
  price: number
  className?: string
}

export default function UsdPrice({ price, className = '' }: UsePriceProps) {
  const algoUsd = useStore((state) => state.algoUsd)

  if (algoUsd > 0) {
    return (
      <span
        className={classNames('text-gray-400 text-xs font-medium whitespace-nowrap', className)}
      >
        &#8776; {`$${convertMicroAlgosToUsd(price, algoUsd)}`}
      </span>
    )
  }

  return null
}
